<template>
  <div ref="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "WrapFlowLayout",
  props: {
    minWidth: {
      type: Number,
      default: 100,
    },
    gap: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    const container = this.$refs.container;
    const children = container.querySelectorAll(":scope > *");
    children.forEach((child) => (child.style.minWidth = this.minWidth));

    container.style.gridTemplateColumns = `repeat(auto-fit, minmax(${this.minWidth}px, 1fr))`;
    container.style.gap = `${this.gap}px`;
  },
};
</script>

<style scoped>
div {
  width: 100%;
  margin: 3em 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 1em;
}

.div > * {
  min-width: 100px;
}
</style>
